import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { onlyNumber } from "../../constant/utils";
import { validatPHP, validateGurugramLab, validatePreventiveHltPkg } from "../../constant/validation";
import { submitAction } from "../../redux/action";
import { useLocation } from "react-router-dom";
import { ROUTE } from "../../route/Route";
import Recaptcha from "../ReCaptcha";

const initialValue = {
  Name: "",
  Mobile: "",
  CityId: "",
  QueryNature: "",
  Message: "",
  UtmSource: "",
  UtmMedium: "",
  UtmCampaign: "",
  Checkbox: false,
  GRecaptcha: "",
};

const GurugramForm = (props: any) => {
  const { pageSource } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const cityData = useSelector((state: any) => state.dashboard.cityAll);
  const [isButtonDisabled, setButtonDisabled] = useState(false);

  const handleSubmit = (values: any) => {
    let data: any = values;
    data.SourceUrl = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    data.UtmSource = urlParams.get("utm_source");
    data.UtmMedium = urlParams.get("utm_medium");
    data.UtmCampaign = urlParams.get("utm_campaign");
    if (window.location.pathname === ROUTE.PREVENTIVEHEALTHPKJ) {
      data.QueryNature = values?.QueryNature;
      data.Message = values?.Message;
      data.GRecaptcha = undefined;
    } else {
      data.QueryNature = undefined;
      data.Message = undefined;
    }
    dispatch(submitAction.submitEnquiryAction(data, history));
    setButtonDisabled(true);
  };
  return (
    <div className="h-services mt-3 mt-md-0">
      <div className="infobox_wrapper">
        <Formik
          initialValues={initialValue}
          enableReinitialize={true}
          validationSchema={
            window.location.pathname === ROUTE.PREVENTIVEHEALTHPKJ ? validatePreventiveHltPkg : validateGurugramLab
          }
          onSubmit={(val: any) => {
            handleSubmit(val);
          }}
          render={({ values, handleChange, errors, touched, handleBlur, handleSubmit, setFieldValue }:any) => (
            <form onSubmit={handleSubmit} style={{ width: "100%" }}>
              <h6 className="ln-1 mr-10">{t("gurugram_form_title")}</h6>
              <div className="ln-1 mr-10">{t("neurology_form_note")}</div>
              <div className="form-group">
                <input
                  type="text"
                  name="Name"
                  className="form-control"
                  placeholder={t("name")}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.Name}
                />
                {touched?.Name && errors?.Name && <span className="error_message">{t(errors?.Name)}</span>}
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="Mobile"
                  className="form-control"
                  placeholder={t("mobile_number")}
                  onKeyPress={onlyNumber}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.Mobile}
                />
                {touched?.Mobile && errors?.Mobile && <span className="error_message">{t(errors?.Mobile)}</span>}
              </div>
              <div className="form-group">
                <select
                  className="form-control"
                  name="CityId"
                  id="CityId"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.CityId}
                >
                  <option value="">{t("city-with*")}</option>
                  {cityData &&
                    cityData.length > 0 &&
                    cityData?.map((item: any, i: any) => (
                      <option value={item?.Id} key={i} className="text-uppercase">
                        {t(item?.Name)}
                      </option>
                    ))}
                </select>
                {touched?.CityId && errors?.CityId && <span className="error_message">{t(errors?.CityId)}</span>}
              </div>
              {window.location.pathname === ROUTE.PREVENTIVEHEALTHPKJ && (
                <>
                  <div className="form-group">
                    <select
                      className="form-control"
                      name="QueryNature"
                      id="QueryNature"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.QueryNature}
                    >
                      <option value="">{t("query_nature")} </option>
                      <option value="Preventive Health Check" className="text-uppercase">
                        Preventive Health Check
                      </option>
                      <option value="Diagnostic Test" className="text-uppercase">
                        Diagnostic Test
                      </option>
                      <option value="Other" className="text-uppercase">
                        Other
                      </option>
                    </select>
                  </div>
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      placeholder={t("message")}
                      name="Message"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.Message}
                    ></textarea>
                  </div>
                </>
              )}
              <div className="d-flex for-check-style">
                <input type="checkbox" name="Checkbox" onChange={handleChange} onBlur={handleBlur} id="checkbox_id" />
                <label className="mx-2" htmlFor="checkbox_id">
                  By clicking you accept to the{" "}
                  <a className="text-info" href="https://oncquestlabs.com/terms-condition">
                    terms and conditions
                  </a>{" "}
                  and the{" "}
                  <a className="text-info" href="https://oncquestlabs.com/privacy-policy">
                    Privacy Policy.
                  </a>
                </label>
              </div>
              <div>
                {touched?.Checkbox && errors?.Checkbox && <span className="error_message">{errors?.Checkbox}</span>}
              </div>
              {window.location.pathname !== ROUTE.PREVENTIVEHEALTHPKJ && (
                <div className="form-group">
                  <Recaptcha
                    touch={touched?.GRecaptcha}
                    error={errors?.GRecaptcha}
                    onChange={(token: any) => setFieldValue("GRecaptcha", token)}
                    onExpired={() => setFieldValue("GRecaptcha", "")}
                  />
                </div>
              )}
              <button type="submit" disabled={isButtonDisabled} className="book--hexagon active">
                <span>
                  {t("submit_btn")}
                  <i className="fa fa-long-arrow-right ml-20" aria-hidden="true"></i>
                </span>
              </button>
            </form>
          )}
        />
      </div>
    </div>
  );
};

export default GurugramForm;
